import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Flex } from '../../../components/Flex';
import { adminSliceSelectors } from '../../../redux/admin/admin.selector';
import { useAppSelector } from '../../../redux/store';
import { Spacing } from '../../../theme/Spacing';
import { AdminStatsWidget } from '../components/AdminStatsWidget';

const Container = styled(Flex)`
  justify-content: space-between;
  flex-wrap: wrap;
  height: 100%;

  & > div:nth-child(odd) {
    margin-inline-end: ${Spacing.s};
  }
`;

export const AdminStatsTab: React.FC = () => {
  const { t } = useTranslation();

  const stats = useAppSelector(adminSliceSelectors.selectAdminStats);

  return (
    <Container>
      <AdminStatsWidget
        title={t('common.users')}
        stats={[
          { key: t('admin.users.total'), value: stats?.users?.total ?? 0 },
          {
            key: t('admin.users.last_week'),
            value: stats?.users?.lastWeek ?? 0,
          },
          {
            key: t('admin.users.last_month'),
            value: stats?.users?.lastMonth ?? 0,
          },
        ]}
      />

      <AdminStatsWidget
        title={t('common.atira_links')}
        stats={[
          {
            key: t('admin.atira_link.total'),
            value: stats?.atiraLinks?.total ?? 0,
          },
          {
            key: t('admin.atira_link.last_week'),
            value: stats?.atiraLinks?.lastWeek ?? 0,
          },
          {
            key: t('admin.atira_link.last_month'),
            value: stats?.atiraLinks?.lastMonth ?? 0,
          },
        ]}
      />

      <AdminStatsWidget
        title={t('common.short_urls')}
        stats={[
          { key: t('admin.url.total'), value: stats?.shortURLs?.total ?? 0 },
          {
            key: t('admin.url.last_week'),
            value: stats?.shortURLs?.lastWeek ?? 0,
          },
          {
            key: t('admin.url.last_month'),
            value: stats?.shortURLs?.lastMonth ?? 0,
          },
        ]}
      />

      <AdminStatsWidget
        title={t('common.qrs')}
        stats={[
          { key: t('admin.qr.total'), value: stats?.QRs?.total ?? 0 },
          { key: t('admin.qr.last_week'), value: stats?.QRs?.lastWeek ?? 0 },
          { key: t('admin.qr.last_month'), value: stats?.QRs?.lastMonth ?? 0 },
        ]}
      />
    </Container>
  );
};
